import styled from "styled-components"
import {TextButton} from "@irati/ui/src/Button"
import theme from "@irati/ui/src/global/theme"

interface StyledProps {
  selected: boolean
}

const TrophyButton = styled<StyledProps, TextButton>(TextButton)`
  padding: ${theme.spacing.one};
  ${({selected}) =>
    selected &&
    `
    background-color: ${theme.colors.greys.lightest}
  `}
`
export default TrophyButton
